import { EditorialValueCard } from '../types/editorial-value-card.type';

import toteIllustration from '../../assets/img/zero_sac_1.png';
import kraftBagIllustration from '../../assets/img/zero_sac_2.png';
import kraftPouchIllustration from '../../assets/img/zero_sac_3.png';
import tomatoIllustration from '../../assets/img/zero_tomate.png';
import strawberryIllustration from '../../assets/img/zero_fraise.png';
import toteReturnIllustration from '../../assets/img/zero_sac_cabas_1.png';
import toteKeepIllustration from '../../assets/img/zero_sac_cabas_2.png';
import toteRecycleIllustration from '../../assets/img/zero_sac_recycle.png';
import kraftFoldIllustration from '../../assets/img/zero_sac_kraft.png';
import pouchIllustration from '../../assets/img/zero_sac_sachet.png';

// Contenu relevé sur la page legacy /zero-dechets (src/views/Front/NosValeurs/ZeroDechets.js).
export const ZERO_WASTE_HERO = {
  // Le legacy titre « Zéro Dechet », sans accent et au singulier ; on s'aligne sur le menu.
  title: 'Zéro déchet',
  lead:
    "L'écologie et le respect de la terre sont au cœur même de la démarche de Bio Culture. Depuis sa création, nous veillons à limiter l'impact écologique de l'entreprise en proposant des solutions d'emballage respectueuses de l'environnement.",
  highlight: 'Un panier Bio = 0 % de déchet non renouvelable ou réutilisable',
};

export const ZERO_WASTE_PACKAGINGS: EditorialValueCard[] = [
  {
    illustration: toteIllustration,
    illustrationAlt: 'Un sac-cabas Bio Culture',
    lead:
      'Nos sacs-cabas, qui transportent vos fruits et légumes, sont fabriqués à partir de 20 à 80 % de matière recyclée issue des déchets de production, et sont 100 % recyclables comme réutilisables.',
  },
  {
    illustration: kraftBagIllustration,
    illustrationAlt: 'Un sac kraft',
    lead: 'Nos sacs kraft sont réutilisables, biodégradables et recyclables. Ils sont de fabrication européenne.',
  },
  {
    illustration: kraftPouchIllustration,
    illustrationAlt: 'Un sachet kraft',
    lead:
      'Nos sachets kraft sont biodégradables et recyclables, issus de forêts à gestion durable et de fabrication française. Pensez au tri sélectif.',
  },
];

export const ZERO_WASTE_CALL = {
  text:
    "Nous vous invitons à participer à notre démarche en redonnant vos sacs Bio Culture à votre livreur, à votre point relais ou dans votre entreprise, afin qu'ils soient réutilisés lors d'une prochaine commande.",
  highlight: "C'est grâce aux petites contributions qu'il y a de grandes avancées.",
  leftIllustration: tomatoIllustration,
  leftIllustrationAlt: 'Une tomate',
  rightIllustration: strawberryIllustration,
  rightIllustrationAlt: 'Une fraise',
};

// Ce ne sont pas des étapes mais des cas de figure exclusifs : le legacy les reliait par des
// flèches, qui laissaient croire à une succession alors qu'on choisit selon l'état du sac.
export const ZERO_WASTE_DISPOSALS = [
  {
    title: 'Mon sac cabas',
    cases: [
      {
        illustration: toteReturnIllustration,
        illustrationAlt: 'Un sac-cabas rendu au livreur',
        lead: 'Je le redonne en point relais ou au livreur, pour une nouvelle utilisation.',
      },
      {
        illustration: toteKeepIllustration,
        illustrationAlt: 'Un sac-cabas gardé pour ses courses',
        lead: "J'ai le droit d'en conserver un pour mes courses.",
      },
      {
        illustration: toteRecycleIllustration,
        illustrationAlt: 'Un sac-cabas jeté au recyclage',
        lead: "S'il est abîmé, je le mets dans la poubelle « Recyclé » : il est entièrement recyclable.",
      },
    ] as EditorialValueCard[],
  },
  {
    title: 'Mon sac kraft',
    cases: [
      {
        illustration: kraftFoldIllustration,
        illustrationAlt: 'Un sac kraft plié',
        lead:
          "S'il est en bon état, je le plie proprement et je le redonne à mon livreur : nous lui donnerons une seconde vie.",
      },
      {
        illustration: toteKeepIllustration,
        illustrationAlt: 'Un sac kraft jeté au recyclage',
        lead: "S'il est abîmé, je le mets dans la poubelle « Recyclé » : il est entièrement recyclable.",
      },
    ] as EditorialValueCard[],
  },
  {
    title: 'Mes sachets',
    cases: [
      {
        illustration: pouchIllustration,
        illustrationAlt: 'Un sachet kraft',
        lead: 'Nous ne les réutilisons pas, à cause de leur fragilité au second usage.',
      },
      {
        illustration: toteKeepIllustration,
        illustrationAlt: 'Un sachet mis au compost',
        lead: 'Je peux les mettre au compost, ou dans ma poubelle « spéciale papier » pour qu\'ils soient recyclés.',
      },
    ] as EditorialValueCard[],
  },
];
